import classExtractFieldDescriptor from './_class_extract_field_descriptor.mjs';
import classApplyDescriptorDestructureSet from './_class_apply_descriptor_destructure.mjs';

export default function _classPrivateFieldDestructureSet(receiver, privateMap) {
  var descriptor = classExtractFieldDescriptor(receiver, privateMap, "set");
  return classApplyDescriptorDestructureSet(receiver, descriptor);
}
